module.exports = __webpack_public_path__ + "img/menu.cb0b139a.svg";